import AnimationRevealPage from "helpers/AnimationRevealPage";
import React from "react";
import { useParams, Link } from "react-router-dom";
import Footerr from "./footers/Footer";
import Light from "./headers/light";
import './BlogDetail.css';

// Example blog data
const blogPosts = {
  romarin: {
    title: "Le Romarin",
    date: "September 20, 2022",
    author: "rehabbio",
    image: "/images/romarin.webp", // make sure this image is in public/images
    content: `
    Arbrisseau de rocaille à l’état sauvage, le romarin, de la famille des lamiacées, peut atteindre 2 m de hauteur, en culture. On le reconnait, aisément, toute l’année, érigé au milieu des buissons méditerranéens : ses feuilles persistantes sont enroulées sur leurs bords. Elles sont beaucoup plus longues que larges, d’une couleur vert sombre, luisant sur leur face supérieure et à la teinte blanchâtre sur le dessous. Ses fleurs, le plus souvent d’une teinte bleu violacé (les blanches sont plus rares) s’agrègent en grappes courtes, de février à mai. Leur calice a un aspect duveteux, la corolle est bilabiée et dotée de quatre étamines, dont deux dépassent la lèvre supérieure. Le fruit du romarin, de forme globuleuse, est un tétrakène brun.
    Le romarin fait l’objet de très nombreuses mentions historiques et légendaires. Les anciens lui vouaient une grande vénération. On s’en servait généreusement dans toutes les fêtes, qu’il s’agisse de cérémonies nuptiales, funéraires ou de célébrations profanes. Les mariées portaient des couronnes de romarin, symboles d’amour et de fidélité, tandis que les invités recevaient des branches enjolivées de rubans de soie multicolores. On mettait aussi des brins de romarin sous les oreillers pour chasser les mauvais esprits et les cauchemars.

Les Égyptiens plaçaient des rameaux de romarin dans la tombe des pharaons afin de fortifier leur âme. Le romarin est un symbole du souvenir et de l’amitié. Les étudiants grecs s’en confectionnaient des couronnes, qu’ils portaient durant les examens pour stimuler leur mémoire.

Durant les épidémies de peste, le romarin était très populaire : on en faisait brûler des rameaux pour purifier l’air et on portait des sachets sur soi, que l’on respirait lorsqu’on passait dans les endroits touchés par cette terrible maladie. L’histoire veut aussi que la reine de Hongrie, qui souffrait de rhumatismes chroniques, ait été délivrée de ses problèmes grâce à un remède à base de romarin lorsqu’elle était âgée de 72 ans.

Dans certaines régions rurales, on fait tremper du romarin dans du vin rouge pour obtenir une boisson fortifiante. On utilise aussi le romarin sous forme d’extrait à base d’alcool pour les plaies et sous forme d’onguent ou de baume pour soulager les rhumatismes et les névralgies, tant chez les humains que chez les animaux.

L’huile essentielle de romarin est largement utilisée comme composant aromatique dans l’industrie des cosmétiques (savons, parfums, crèmes, etc.), mais aussi dans l’industrie alimentaire (boissons alcoolisées, desserts, bonbons, conservation des lipides, etc.).
Principes actifs:
Ses huiles essentielles renferment des essences de camphre, de cinéol, de verbénone ou de pinènes. Le romarin contient des flavonoïdes (diosmine, lutéoline), des diterpènes, comme le rosmadial et l’acide carnosolique, mais aussi des lipides (alcanes et alcènes). On trouve également des stéroïdes et des triterpènes (acide aléanolique, acide ursotique) et des acides phénoliques (acide rosmarinique, acide chlorogénique). Des phytoestrogènes ont des effets comparables aux hormones féminines.


  `,
  },
  psoriasis: {
    title: "Le Psoriasis",
    date: "September 20, 2022",
    author: "rehabbio",
    image: "/images/psoriasis.webp", // make sure this image is in public/images
    content: `
    Le psoriasis est une maladie inflammatoire de la peau. Elle se caractérise généralement par l’apparition
d’épaisses plaques de peau squameuse (se détachant sous forme de « flocons » blancs).
Les plaques apparaissent à de nombreux endroits différents sur le corps, le plus souvent sur les coudes, les genoux et le cuir chevelu. Elles laissent des zones de peau rouge.
Cette maladie chronique évolue par cycles, avec des périodes de rémission. Elle n’est pas contagieuse et peut être bien maîtrisée par les traitements.

Le psoriasis peut être très désagréable ou même douloureux lorsqu’il se manifeste sur la paume des mains, la plante du pied ou dans les plis de la peau. L’ampleur de la maladie varie grandement d’un individu à l’autre. 
En fonction de l’emplacement des plaques et de leur étendue, le psoriasis peut être gênant et nuisible à la vie sociale. En effet, le regard d’autrui sur les maladies cutanées est souvent douloureux.
Il existe plusieurs types de psoriasis. La forme la plus courante est le psoriasis en plaques, aussi appelé psoriasis vulgaire (car il représente plus de 80 % des cas).

Il se caractérise par des plaques rouges, bien limitées, épaisses, recouvertes de squames blanchâtres, qui se situent principalement sur le cuir chevelu, les coudes, les genoux et le bas du dos bien que des plaques puissent également être trouvées sur d’autres parties du corps.

• Le psoriasis en gouttes:
Moins de 10% des cas. Cette forme est fréquente chez les enfants et les adolescents après une angine de poitrine. Il apparaît soudainement sous la forme  de nombreuses petites tahcess de quelques millimètres de diamètre,  principalement sur le tronc. Cette forme de psoriasis peut parfois évoluer vers le psoriasis vulgaire.

• Le psoriasis pustuleux:
Il est caractérisé par l’apparition de minuscules pustules sur des plaques rouges. Ces pustules ne contiennent pas de microbes: elles sont liées à l’intensité de l’inflammation.

On distingue :

La forme localisée, qui atteint uniquement les paumes des mains et/ou les plantes des pieds (pustulose palmo
– plantaire).
La forme qui touche le bout des doigts, avec des pustules qui se renouvellent constamment (acrodermatite continue de Hallopeau).
 
• Le psoriasis érythrodermique : forme généralisée
Il peut affecter toute la surface de la peau sous forme de pustules disséminées dans des zones rouges et enflammées (psoriasis pustuleux de  Zumbusch). Toujours accompagnée de fièvre et de frissons. Ce psoriasis généralisé très rare est grave et nécessite un traitement rapide.
Les causes et éléments déclenchants:
De nombreux facteurs jouent un rôle complexe dans le développement du psoriasis. Aujourd’hui, on pense qu’il s’agit d’une maladie auto-immune qui se développe chez les personnes qui ont une prédisposition appropriée et qui sont sous l’influence de certains facteurs dits favorables.

• Une maladie auto-immune:
Des cellules immunitaires spécifiques présentes dans la peau sont activées chez les patients atteints de psoriasis et jouent un rôle important à la fois dans la prolifération des cellules superficielles de l’épiderme et  dans l’initiation et l’entretien des phénomènes inflammatoires.

• Une prédisposition génétique:
Bien que le psoriasis soit une maladie à composante génétique, il ne se transmet pas systématiquement de génération en génération. Au mieux, nous héritons de gènes qui nous prédisposent au psoriasis. 

• Des facteurs favorisants ou aggravants:
Le grattage, les traumatismes cutanés, certaines infections ORL, le stress, la prise de certains médicaments, le surpoids, l’excès d’alcool ou de tabac, les saisons peuvent être des facteurs déclenchant ou aggravant les poussées de psoriasis.

Les complications possibles:
Selon les individus, la maladie évolue par étapes assez imprévisibles et très différentes. Les symptômes durent généralement 3 à 4 mois. Elle disparaît ensuite (en rémission) au fil des mois ou des années et réapparaît le plus souvent.

Les personnes atteintes  de psoriasis modéré ou sévère peuvent avoir un impact énorme sur leur apparence et, par conséquent, éprouver du stress, de l’anxiété, de la solitude, une perte d’estime de soi et même de la dépression.

Les personnes atteintes de psoriasis semblent être plus susceptibles de souffrir de maladies cardiovasculaires, de syndrome métabolique et d’obésité, mais nous ne savons toujours pas pourquoi.
  `,
  },
  soin: {
    title: "Comment prendre soin de soi d'une manière responsable ?",
    date: "September 20, 2022",
    author: "rehabbio",
    image: "/images/soin.webp", // make sure this image is in public/images
    content: `
    Pour un bien-être physique, physiologique et psychique, il est important de savoir prendre soin de soi. Cela implique une bonne alimentation et des soins esthétiques appropriés. Pour mieux prendre soin de soi sans pour autant porter atteinte à l’écosystème, voici quelques astuces à envisager.

Utiliser des produits cosmétiques naturels et éthiques
Lorsqu’on parle d’un mode de vie sain, beaucoup de personnes ignorent l’importance du maquillage. Il consiste pourtant à prendre soin de votre corps et la plupart des produits utilisés ne sont malheureusement pas écoresponsables. Leur production a généralement un impact négatif sur l’environnement et leur utilisation sur votre peau n’est pas sans conséquence. Les composants de ces produits sont généralement nocifs pour la peau et le sang.

Si nous commençons ces conseils par ce volet, c’est pour vous rappeler votre implication et votre capacité à renverser la vapeur. Vous pouvez rester belle tout en préservant la nature ainsi que votre bien-être et cela passe par l’utilisation de produits cosmétiques naturelles qui ne représentent aucune menace pour ou votre environnement. En optant pour les cosmétiques 100 % naturels bio comme ceux proposés sur Rehab Bio Cosmetics par exemple, vous avez la garantie d’avoir des produits :

Inoffensifs pour votre corps,
Très nutritifs,
Faciles à utiliser,
Adaptés à tout type de peaux.
En plus de vous faire bénéficier de ces différents avantages, les produits naturelles sont contrôlés avec rigueur et participent à la sauvegarde de l’environnement. Les acides aminés et gras contenus dans les ingrédients naturels utilisés sont particulièrement adaptés pour votre peau. Par conséquent, ils s’intègrent plus facilement et participent à la création d’une barrière protectrice efficace pour le derme. De plus, aucun résidu nocif n’est stocké dans le corps après leur utilisation.
Opter pour des fruits et légumes de saison
Les nutritionnistes nous conseillent souvent une alimentation saine essentiellement constituée de fruits et légumes. Il est bien de respecter cela pour son propre bien-être et pour celui de l’environnement. Il est préférable de consommer les produits de saison. Vous devez bannir les aliments issus d’une agriculture impliquant des intrants et autres systèmes qui dégradent l’environnement.

Miser sur des vêtements écoresponsables
Pour se sentir bien dans sa peau, il faut se sentir à l’aise dans ses vêtements et surtout sans nuire à son environnement. Une chose est d’être à la mode, mais une autre est de l’être tout en étant responsable. Pour cela, nous vous conseillons d’opter pour une mode éthique, qui consiste en l’utilisation des vêtements écoresponsables.

De nombreuses marques en proposent, car la question de l’environnement implique tout le monde. Une manière de vérifier si vos accessoires respectent cette logique est de vérifier :

leur provenance,
leur composition,
le label environnemental.
Toutes ces informations se retrouvent généralement sur les étiquettes des produits. Par ailleurs, vous pouvez aussi privilégier les vêtements seconde main, mais aussi penser au recyclage de ceux que vous ne portez plus.
  `,
  },
  // add other posts here
};

const BlogDetail = () => {
  const { slug } = useParams();
  const post = blogPosts[slug];

  if (!post) {
    return <h2 className="text-center mt-10 text-red-500 font-semibold text-xl">Article introuvable ❌</h2>;
  }

  return (
    <AnimationRevealPage>
      <Light />
<br/>
      <div className="max-w-3xl mx-auto px-6 py-16">
        {/* Retour */}
       

        {/* Titre */}
     <h1 className="post-title1">
  {post.title}
</h1>


        {/* Meta */}
       

        {/* Image */}
       <div className="overflow-hidden rounded-xl shadow-md mb-10">
  <img
    src={post.image}
    alt={post.title}
    className="w-full h-auto object-cover post-image1"
  />
</div>
<div className="text-gray-700 text-lg leading-relaxed post-content1">
  {post.content.split("\n\n").map((paragraph, idx) => (
    <p key={idx} className="mb-4">{paragraph}</p>
  ))}
</div>


      </div>
<p className="text-sm text-gray-500 mb-8 post-meta1">
  {post.date} • Par {post.author}
</p>

      <Footerr />
    </AnimationRevealPage>
  );
};

export default BlogDetail;
